export default __webpack_public_path__ + "build/d1475e067b50f77a838883b981d5fcaa.svg";